{
  "_format": "hh-sol-artifact-1",
  "contractName": "LYTPoolServiceConfiguration",
  "sourceName": "contracts/LYTPoolServiceConfiguration.sol",
  "abi": [
    {
      "inputs": [],
      "name": "AccessControlBadConfirmation",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "internalType": "bytes32",
          "name": "neededRole",
          "type": "bytes32"
        }
      ],
      "name": "AccessControlUnauthorizedAccount",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "target",
          "type": "address"
        }
      ],
      "name": "AddressEmptyCode",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "implementation",
          "type": "address"
        }
      ],
      "name": "ERC1967InvalidImplementation",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ERC1967NonPayable",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "FailedCall",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "InvalidInitialization",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "LiquidityAssetNoOp",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NotInitializing",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "UUPSUnauthorizedCallContext",
      "type": "error"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "slot",
          "type": "bytes32"
        }
      ],
      "name": "UUPSUnsupportedProxiableUUID",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "UpgradeRevert",
      "type": "error"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "_account",
          "type": "address"
        }
      ],
      "name": "Blacklisted",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint64",
          "name": "version",
          "type": "uint64"
        }
      ],
      "name": "Initialized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "factory",
          "type": "address"
        }
      ],
      "name": "LYTPoolFactorySet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "addr",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "bool",
          "name": "value",
          "type": "bool"
        }
      ],
      "name": "LiquidityAssetSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "ParameterSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "factory",
          "type": "address"
        }
      ],
      "name": "PoolRegistrySet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "bool",
          "name": "paused",
          "type": "bool"
        }
      ],
      "name": "ProtocolPaused",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "previousAdminRole",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "newAdminRole",
          "type": "bytes32"
        }
      ],
      "name": "RoleAdminChanged",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "sender",
          "type": "address"
        }
      ],
      "name": "RoleGranted",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "sender",
          "type": "address"
        }
      ],
      "name": "RoleRevoked",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "_account",
          "type": "address"
        }
      ],
      "name": "UnBlacklisted",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "implementation",
          "type": "address"
        }
      ],
      "name": "Upgraded",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "AUTOMATION_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "DEFAULT_ADMIN_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "DEPLOYER_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "FEE_COLLECTOR",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "FIAT_GATEWAY",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "ISSUER_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "OPERATOR_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "PROTOCOL_ADMIN",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "UPGRADE_INTERFACE_VERSION",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_account",
          "type": "address"
        }
      ],
      "name": "blacklist",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getLYTPoolFactory",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getLegacyFactories",
      "outputs": [
        {
          "components": [
            {
              "internalType": "enum IFactoryType",
              "name": "factoryType",
              "type": "uint8"
            },
            {
              "internalType": "address",
              "name": "factoryAddress",
              "type": "address"
            }
          ],
          "internalType": "struct LegacyFactoryStruct[]",
          "name": "",
          "type": "tuple[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getPoolRegistry",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        }
      ],
      "name": "getRoleAdmin",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getServiceAddressListV5",
      "outputs": [
        {
          "components": [
            {
              "internalType": "address[]",
              "name": "liquidityAssets",
              "type": "address[]"
            },
            {
              "internalType": "address",
              "name": "poolAccessControlFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolRegistryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "lytPoolFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "lytPoolControllerFactoryAddress",
              "type": "address"
            }
          ],
          "internalType": "struct ServiceAddressListV5",
          "name": "serviceAddressList",
          "type": "tuple"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "grantRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "hasRole",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "initialize",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isAutomation",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isBlacklisted",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isDeployer",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isFeeCollector",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isFiatGateway",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isIssuer",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "isLiquidityAsset",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isOperator",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isProtocolAdmin",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "legacyFactories",
      "outputs": [
        {
          "internalType": "enum IFactoryType",
          "name": "factoryType",
          "type": "uint8"
        },
        {
          "internalType": "address",
          "name": "factoryAddress",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "liquidityAssetKeys",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "lytPoolFactory",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "paused",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "poolRegistry",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "proxiableUUID",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "callerConfirmation",
          "type": "address"
        }
      ],
      "name": "renounceRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "revokeRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setLYTPoolFactory",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        },
        {
          "internalType": "bool",
          "name": "value",
          "type": "bool"
        }
      ],
      "name": "setLiquidityAsset",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bool",
          "name": "paused_",
          "type": "bool"
        }
      ],
      "name": "setPaused",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setPoolRegistry",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes4",
          "name": "interfaceId",
          "type": "bytes4"
        }
      ],
      "name": "supportsInterface",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_account",
          "type": "address"
        }
      ],
      "name": "unBlacklist",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newImplementation",
          "type": "address"
        },
        {
          "internalType": "bytes",
          "name": "data",
          "type": "bytes"
        }
      ],
      "name": "upgradeToAndCall",
      "outputs": [],
      "stateMutability": "payable",
      "type": "function"
    }
  ],
  "bytecode": "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",
  "deployedBytecode": "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",
  "linkReferences": {},
  "deployedLinkReferences": {}
}
